import { create } from 'zustand'
import type { HelpdeskRequest } from '@/types/helpdesk'

export type ParentTicketDraft = {
  requestId: string
  requestorName: string
  clientOrg: string
  serialNumber: string
  unitModelRecord: string
  serviceType: string
  issueDescription: string
  requestDatetime: string
  subject?: string
  requestType?: string
  contactName?: string
  contactEmail?: string
  requestSource?: string
}

type ParentTicketDraftState = {
  draft: ParentTicketDraft
  hydratedFromRequestId?: string
  hydrateFromRequest: (request: HelpdeskRequest) => void
}

const initialDraft: ParentTicketDraft = {
  requestId: '',
  requestorName: '',
  clientOrg: '',
  serialNumber: '',
  unitModelRecord: '',
  serviceType: '',
  issueDescription: '',
  requestDatetime: '',
}

function normalizeServiceType(requestType: HelpdeskRequest['requestType']): string {
  if (requestType === 'Break fix') return 'Breakfix'
  return requestType
}

export const useParentTicketDraftStore = create<ParentTicketDraftState>(
  (set, get) => ({
    draft: initialDraft,
    hydratedFromRequestId: undefined,
    hydrateFromRequest: (request) => {
      if (get().hydratedFromRequestId === request.id) {
        return
      }

      set((state) => ({
        draft: {
          ...state.draft,
          requestId: request.id,
          requestorName: request.clientName ?? state.draft.requestorName,
          clientOrg: request.clientOrg ?? state.draft.clientOrg,
          serialNumber: request.serialNumber ?? state.draft.serialNumber,
          unitModelRecord: request.unitModel ?? state.draft.unitModelRecord,
          serviceType: normalizeServiceType(request.requestType),
          issueDescription:
            state.draft.issueDescription || request.subject || request.description || '',
          requestDatetime: request.requestedAt || state.draft.requestDatetime,
          subject: request.subject,
          requestType: request.requestType,
          contactName: request.contactName ?? state.draft.contactName,
          contactEmail: request.contactEmail ?? state.draft.contactEmail,
          requestSource: request.requestSource ?? state.draft.requestSource,
        },
        hydratedFromRequestId: request.id,
      }))
    },
  }),
)

